import React from "react";
import dynamic from "next/dynamic";
import { useBusinessProfile } from "hooks/useFetch";
import { RenderMethod } from "types/business.types";

const ProvidersList = dynamic(() => import("./List.providers"), {
	ssr: true,
});

type Props = { providersCount: number };

export default function ProviderContainer({ providersCount }: Props) {
	const { data: businessProfile } = useBusinessProfile();
	const widgetSetting = businessProfile?.data.widget;
	const renderMethod = widgetSetting?.settings.provider.renderMethod;

	if (providersCount > 0) {
		if (renderMethod !== RenderMethod.NoRender) {
			return <ProvidersList />;
		} else {
			// No render
			return null;
		}
	} else {
		return null;
	}
	// else {
	// 	return <EmptyState section="providers" />;
	// }
}
